import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import OrgChartPdfPage from '@/pages/export/org-chart'

export const Route = createFileRoute('/export/org-chart/')({
  validateSearch: z.object({ token: z.string() }),
  component: OrgChartPdfPage,
})
